export enum PostType {
	NEWS = "NEWS",
	PROJECT = "PROJECT",
	BLOG = "BLOG",
}
